import styled from "styled-components"
import Select from "../Select"

export const StyledLanguageSwitch = styled(Select)`
  text-transform: uppercase;
`
